var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "ai-container"
  }, [_c('div', {
    staticClass: "img-content",
    on: {
      "click": _vm.goThird
    }
  }, [_c('img', {
    staticClass: "img-item",
    attrs: {
      "src": _vm.aiNoteObj.image
    }
  })]), _c('div', {
    staticClass: "content"
  }, [_vm.aiNoteObj.title ? _c('div', {
    staticClass: "content-title"
  }, [_vm._v(_vm._s(_vm.aiNoteObj.title))]) : _vm._e(), _c('div', {
    staticClass: "content-des",
    domProps: {
      "innerHTML": _vm._s(_vm.aiNoteObj.sub_title)
    }
  })])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };